var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m78msq9mga"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1255H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f25o96x2pb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68 0c.202 0 .366.17.366.381v.763h1.097c.606 0 1.097.512 1.097 1.144v8.088c0 .632-.491 1.144-1.097 1.144H1.097C.491 11.52 0 11.008 0 10.376V2.288c0-.632.491-1.144 1.097-1.144h1.097V.381c0-.21.164-.381.366-.381.202 0 .366.17.366.381v.763h4.388V.381c0-.21.164-.381.366-.381zm1.829 4.577H.73v5.799c0 .21.164.381.366.381h8.046c.202 0 .366-.17.366-.381v-5.8zm-7.315-2.67H1.097a.374.374 0 0 0-.366.381v1.526H9.51V2.288a.374.374 0 0 0-.366-.381H8.046v.763c0 .21-.164.381-.366.381a.374.374 0 0 1-.366-.381v-.763H2.926v.763c0 .21-.164.381-.366.381a.374.374 0 0 1-.366-.381v-.763z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3rkqk5h93c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.76.108a.388.388 0 0 1 .548.547l-.043.043-.05.05L5.063.9l-.21.21-1.016 1.015-.63.63-.908.906-.092.093a.388.388 0 0 1-.548 0L.883 2.98l-.482-.482-.293-.292a.387.387 0 0 1 .548-.548l.045.045.035.035.165.164.732.733.3.299.775-.775.652-.651.527-.527z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m78msq9mga)",
    transform: "translate(-412 -376)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f25o96x2pb)",
    transform: "translate(413 377)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6B119",
    d: "M0 0h10.24v11.52H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.509 380.814h-8.778v-1.526c0-.21.164-.381.366-.381h1.097v.763c0 .21.164.381.366.381.202 0 .366-.17.366-.381v-.763h4.388v.763c0 .21.164.381.366.381.202 0 .366-.17.366-.381v-.763h1.097c.202 0 .366.17.366.381v1.526zm0 6.562c0 .21-.164.381-.366.381h-8.046a.374.374 0 0 1-.366-.381v-5.8h8.778v5.8zm-.366-9.232h-1.097v-.763a.374.374 0 0 0-.366-.381.374.374 0 0 0-.366.381v.763h-4.388v-.763a.374.374 0 0 0-.366-.381.374.374 0 0 0-.366.381v.763h-1.097c-.606 0-1.097.512-1.097 1.144v8.088c0 .632.491 1.144 1.097 1.144h8.046c.606 0 1.097-.512 1.097-1.144v-8.088c0-.632-.491-1.144-1.097-1.144z",
    stroke: "#F6B119",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3rkqk5h93c)",
    transform: "translate(415.412 382.714)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6B119",
    d: "M0-.001h5.416v3.869H0v-3.87z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.71 382.822a.388.388 0 0 0-.538 0l-2.827 2.825-1.277-1.276a.388.388 0 0 0-.548.548l1.55 1.55a.388.388 0 0 0 .549 0l3.1-3.1a.387.387 0 0 0-.009-.547z",
    stroke: "#F6B119",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSmall);
export default __webpack_public_path__ + "static/media/calender-small.f1f31e9819acabfc125070d2e5abe3c4.svg";
export { ForwardRef as ReactComponent };